import { useQuery } from '@tanstack/react-query';
import {
  disclosureToApsCandidate,
  dxClaimToApsCandidate,
  rxRowToApsCandidate,
} from '../../detail/doctorInfo/candidateMappers';
import { fetchDoctors as fetchMedicalDoctors } from '../../detail/doctorInfo/fetchDoctors';
import { ApsCandidate } from '../../detail/doctorInfo/types';
import { fetchDoctors as fetchTaskDoctors } from '../api';
import { previouslyOrderedToApsCandidate } from '../utils';

const useApsCandidates = (
  applicationId: string,
  taskId: number,
  enabled = true,
) => {
  const { isLoading: isLoadingMedical, data: medicalData } = useQuery({
    queryKey: ['aps-candidates-medical', applicationId],
    queryFn: () => fetchMedicalDoctors(applicationId),
    enabled: enabled && !!applicationId,
    refetchOnWindowFocus: false,
  });

  const { isLoading: isLoadingPrevious, data: previousData } = useQuery({
    queryKey: ['aps-candidates-previous', applicationId, taskId],
    queryFn: () => fetchTaskDoctors(Number(applicationId), taskId),
    enabled: enabled && !!applicationId && !!taskId,
    refetchOnWindowFocus: false,
  });

  const candidates: ApsCandidate[] = [];

  if (medicalData) {
    // Disclosure first, then Dx, then Rx — bucket order preserved for grouping.
    medicalData.disclosure.forEach((row, i) =>
      candidates.push(disclosureToApsCandidate(row, i)),
    );
    medicalData.dx.claims.forEach((row, i) =>
      candidates.push(dxClaimToApsCandidate(row, i)),
    );
    medicalData.rx.forEach((row, i) =>
      candidates.push(rxRowToApsCandidate(row, i)),
    );
  }

  if (previousData) {
    previousData.forEach((row, i) =>
      candidates.push(previouslyOrderedToApsCandidate(row, i)),
    );
  }

  return {
    candidates,
    isLoading: isLoadingMedical || isLoadingPrevious,
  };
};

export default useApsCandidates;
